import { Menu } from '@mui/material';
import type { ReactNode } from 'react';

interface AppMenuProps {
  anchorEl: Element | null;
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

const AppMenu = (props: AppMenuProps) => {
  return (
    <Menu
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left'
      }}
      anchorEl={props.anchorEl}
      open={props.open}
      onClose={props.onClose}
      keepMounted
    >
      {props.children}
    </Menu>
  );
};

export default AppMenu;
